import React from 'react';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import SolidButton from '../../../Buttons/SolidButton';
import BrandedButton from '../../../Buttons/BrandedButton';
import s from './ThumbMiddleContent.scss';
const ThumbMiddleContent = ({ icon, title, subtitle, buttonTitle, onButtonClick, biData, className, buttonHref, buttonStyle, buttonIcon })=>{
    const ButtonComponent = buttonStyle === 'solid' ? SolidButton : BrandedButton;
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK,
        tag: "div",
        className: classnames(s['root'], className)
    }, icon && /*#__PURE__*/ React.createElement("div", {
        className: s['icon']
    }, icon), title && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), subtitle && /*#__PURE__*/ React.createElement("div", {
        className: s['subtitle']
    }, subtitle), buttonTitle && /*#__PURE__*/ React.createElement(ButtonComponent, {
        variant: buttonStyle === 'solid' ? 'main' : 'brand-green',
        icon: buttonIcon,
        size: "medium",
        onClick: onButtonClick,
        href: buttonHref,
        biData: biData,
        className: s['button']
    }, buttonTitle));
};
ThumbMiddleContent.displayName = 'ThumbMiddleContent';
export default ThumbMiddleContent;
